import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from './swal';
import RoadiesShell from './RoadiesShell';
import { GameHead, TopBar, useSaveScore } from './common';
import { useGameTimer, useRotateNotice } from './hooks';

const OPTIONS = [
  { value: 'kransekage', label: 'K R A N S E K A G E' },
  { value: 'kanelstang', label: 'K A N E L S T A N G' },
  { value: 'karbonader', label: 'K A R B O N A D E R' },
];
const CORRECT = 'kransekage';

// s3.php: pick the Danish New Year's treat. Select -> orange, 2s later reveal green/red, +1 if right.
function Stage3Game() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const game = useSelector((s) => s.roadies.game);
  const rotate = useRotateNotice();
  const timer = useGameTimer(true, game?.time);
  const save = useSaveScore();

  const base = game?.totalScore || 0;
  const [points, setPoints] = useState(base);
  const [selected, setSelected] = useState('');
  const [revealed, setRevealed] = useState(false);
  const busy = useRef(false);

  const cls = (v) => {
    if (!revealed) return v === selected ? 'rd-option pending' : 'rd-option';
    if (v === CORRECT) return 'rd-option correct';
    if (v === selected) return 'rd-option wrong';
    return 'rd-option';
  };

  const submit = async () => {
    if (busy.current) return;
    if (!selected) {
      Swal.fire('', 'Please select an option', 'info');
      return;
    }
    busy.current = true;
    setRevealed(true);
    const won = selected === CORRECT;
    const score = base + (won ? 1 : 0);
    setPoints(score);
    setTimeout(async () => {
      const state = await save(3, score, timer.current());
      if (state) navigate({ pathname: '/stage4', search });
      else busy.current = false;
    }, 2000);
  };

  return (
    <>
      {rotate && <div className="rd-rotate">Please rotate your device for the best experience</div>}
      <TopBar time={timer.text} points={points} />
      <GameHead title="Denmark" note="(Select the correct option from the three)">
        Danes enjoy a traditional New Year's Eve meal of boiled cod with mustard, followed by marzipan
        doughnuts called K _ _ _ S _ _ A _ _.
      </GameHead>
      <div className="rd-game">
        <div className="rd-options">
          {OPTIONS.map((o) => (
            <div key={o.value} className={cls(o.value)} onClick={() => !revealed && setSelected(o.value)}>
              {o.label}
            </div>
          ))}
        </div>
        <img src="/roadies/img/demark.png" className="rd-img rd-img-sm" alt="Denmark" />
        <div>
          <button type="button" className="rd-btn" onClick={submit} disabled={revealed}>Submit</button>
        </div>
      </div>
    </>
  );
}

export default function RoadiesStage3() {
  return (
    <RoadiesShell bg="denmark.jpg" bgMob="denmark-mob.jpg" stage={3} className="rd-stage rd-stage3">
      <Stage3Game />
    </RoadiesShell>
  );
}
